/**
 * SysPaymentItem.RID / SysPaymentItemPerAccount.PaymentItemId
 * 仅「按档 Qty 不同」的权益进表；额度以接口/库表为准，前端不做按档兜底。
 */
export const PAYMENT_ITEM_ID = {
  PRODUCT: 1,
  CATALOG: 2,
  UNLOCK_QUOTA: 4,
  ROLE: 5,
  CONTACT_BUYER_DAILY: 6,
  /** 产品图片（每产品） */
  PRODUCT_PHOTO: 7,
  /** 产品视频（每产品；长+短共用） */
  PRODUCT_VIDEO: 8,
  /** 公司图库 */
  COMPANY_GALLERY: 9,
  /** 公司视频（长+短共用） */
  COMPANY_VIDEO: 10,
};

/**
 * 从 getSysAccountPaymentInfo 结果取 Qty
 * @param {Array} rows
 * @param {number} paymentItemId
 * @returns {number|null} null = 未命中
 */
export function pickPaymentItemQty(rows, paymentItemId) {
  if (!Array.isArray(rows) || !rows.length) return null;
  const row = rows.find((a) => Number(a.rid ?? a.RID ?? a.Rid) === Number(paymentItemId));
  if (!row) return null;
  const qty = row.totalQty ?? row.TotalQty ?? row.qty ?? row.Qty;
  if (qty == null || qty === '') return null;
  const n = Number(qty);
  return Number.isFinite(n) ? n : null;
}
